import { getAdminUserById } from './getAdminUserById';
import { getCareAdvisorUserById } from './getCareAdvisorUserById';
import { UserProfile } from './types/UserProfile';
import { UserRoleName } from './types/UserProfile';

// Admin-family roles must not read through /care_advisor/*: that endpoint is
// guarded for the CareAdvisor role alone, so an Admin or SuperAdmin got a 403
// and the user-profile page rendered empty. /admin/users/{id} returns a
// superset of the same payload, so the page consumes either unchanged.
const ADMIN_ROLES: ReadonlySet<string> = new Set([
  UserRoleName.Admin,
  UserRoleName.SuperAdmin,
  UserRoleName.OrganizationAdmin,
]);

export const getStaffUserById = async (user_id: number, role: string): Promise<UserProfile> =>
  ADMIN_ROLES.has(role) ? getAdminUserById(user_id) : getCareAdvisorUserById(user_id);
